import { render, staticRenderFns } from "./NewManagerMessage.vue?vue&type=template&id=6924e4fe&scoped=true&"
import script from "./NewManagerMessage.vue?vue&type=script&lang=js&"
export * from "./NewManagerMessage.vue?vue&type=script&lang=js&"
import style0 from "./NewManagerMessage.vue?vue&type=style&index=0&id=6924e4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924e4fe",
  null
  
)

export default component.exports